import Newnavbar from "../Components/Navbar/Newnavbar";
import {
    IconUser,
    IconBriefcase,
    IconDeviceFloppy,
    IconScale,
    IconMapPin,
    IconMail,
    IconPhone,
    IconBuilding,
} from "@tabler/icons-react";

import {
    Avatar,
    Badge,
    Box,
    Button,
    Card,
    Container,
    Divider,
    Grid,
    Group,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Text,
    TextInput,
    Textarea,
    ThemeIcon,
    Title, Center
} from "@mantine/core";
import { useEffect, useState } from "react";
import { Userauthcontexthooks } from "../Hooks/Userauthcontexthooks";
import { message } from "antd";












const Profile = () => {
    const { user } = Userauthcontexthooks();
    const [submitloading, setSubmitloading] = useState(false);
    const [profileInputs, setProfileInputs] = useState({
        fullname: "",
        mobilenumber: "",
        email: "",
        officeaddress: "",
        city: "",
        state: "",

        barcouncilnumber: "",
        practicecourt: "",
        experience: "",
        specialization: "",
        courtname: "",
        departmentsection: "",
        clerkid: "",
        workingunder: "",
    });

    const HandleChange = (e) => {
        const { name, value } = e.target;

        setProfileInputs({
            ...profileInputs,
            [name]: value,
        });
    };
    const GetIndividualUser = async () => {
        const res = await fetch("https://cdr-backend.onrender.com/get/user-details", {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${user}`
            }
        });

        const Result = await res.json();
        if (res.status === 200) {
            // console.log(Result.ExistingUser);
            // SetUserDetails(Result.ExistingUser);
            setProfileInputs({
                fullname: Result.ExistingUser.Fullname || "",
                mobilenumber: Result.ExistingUser.PhoneNumber || "",
                email: Result.ExistingUser.Email || "",
                officeaddress: Result.ExistingUser.officeaddress || "",
                city: Result.ExistingUser.city || "",
                state: Result.ExistingUser.state || "",

                barcouncilnumber: Result.ExistingUser.barcouncilnumber || "",
                practicecourt: Result.ExistingUser.practicecourt || "",
                experience: Result.ExistingUser.experience || "",
                specialization: Result.ExistingUser.specialization || "",
                courtname: Result.ExistingUser.courtname || "",
                departmentsection: Result.ExistingUser.departmentsection || "",
                clerkid: Result.ExistingUser.clerkid || "",
                workingunder: Result.ExistingUser.workingunder || "",
            })
            return
        } else {
            return;
        }
    }

    // Example user fetch
    useEffect(() => {
        // fetch profile api here
        const GetIndividualUser = async () => {
            const res = await fetch("https://cdr-backend.onrender.com/get/user-details", {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${user}`
                }
            });

            const Result = await res.json();
            if (res.status === 200) {
                // console.log(Result.ExistingUser);
                // SetUserDetails(Result.ExistingUser);
                setProfileInputs({
                    fullname: Result.ExistingUser.Fullname || "",
                    mobilenumber: Result.ExistingUser.PhoneNumber || "",
                    email: Result.ExistingUser.Email || "",
                    officeaddress: Result.ExistingUser.officeaddress || "",
                    city: Result.ExistingUser.city || "",
                    state: Result.ExistingUser.state || "",

                    barcouncilnumber: Result.ExistingUser.barcouncilnumber || "",
                    practicecourt: Result.ExistingUser.practicecourt || "",
                    experience: Result.ExistingUser.experience || "",
                    specialization: Result.ExistingUser.specialization || "",
                    courtname: Result.ExistingUser.courtname || "",
                    departmentsection: Result.ExistingUser.departmentsection || "",
                    clerkid: Result.ExistingUser.clerkid || "",
                    workingunder: Result.ExistingUser.workingunder || "",
                })
                return
            } else {
                return;
            }
        }
        if (user) {
            GetIndividualUser();
        }
    }, [user]);

    const SaveProfile = async () => {
        //console.log(profileInputs);
        const { officeaddress, city, state, barcouncilnumber, practicecourt, experience, specialization, courtname, departmentsection, clerkid, workingunder } = profileInputs
        if (!officeaddress || !city || !state || !practicecourt || !experience || !specialization || !departmentsection) {
            message.error("Please fill all required fields");
            return;
        }
        if (practicecourt === "District Court" || practicecourt === "High Court") {
            if (!courtname) {
                message.error("Please fill all required fields");
                return;
            }
        }
        setSubmitloading(true);
        const res = await fetch('https://cdr-backend.onrender.com/v2/update-user-profile', {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${user}`
            },
            body: JSON.stringify({ officeaddress, city, state, barcouncilnumber, practicecourt, experience, specialization, courtname, departmentsection, clerkid, workingunder })
        })
        if (res.status === 200) {
            message.success("Profile updated successfully");
            GetIndividualUser();
            setSubmitloading(false);
            return
        } else if (res.status === 401) {
            message.error("Unauthorized. Please login again.");
            setSubmitloading(false);
            return
        } else if (res.status === 400) {
            const Result = await res.json();
            message.error(Result.message || "Bad Request");
            setSubmitloading(false);
            return
        } else {
            message.error("Something went wrong. Please try again later.");
            setSubmitloading(false);
            return
        }
    };
    return (
        <>
            <Box
                style={{
                    minHeight: "100vh",
                    background:
                        "linear-gradient(135deg,#020617 0%,#0f172a 40%,#111827 100%)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* BACKGROUND GLOW */}
                <Box
                    style={{
                        position: "absolute",
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "rgba(59,130,246,0.15)",
                        filter: "blur(120px)",
                        top: -100,
                        right: -100,
                    }}
                />
                <Box
                    style={{
                        position: "absolute",
                        width: 400,
                        height: 400,
                        borderRadius: "50%",
                        background: "rgba(168,85,247,0.15)",
                        filter: "blur(120px)",
                        bottom: -100,
                        left: -100,
                    }}
                />
                {/* MAIN CONTENT */}
                <Box
                    px={{ base: "md", md: "xl" }}
                    py={{ base: "md", md: "lg" }}
                    style={{
                        position: "relative",
                        zIndex: 10,
                        paddingBottom: 100,
                    }}
                >
                    <Newnavbar />
                    <Container size="xl" mt="xl">
                        {/* TOP PROFILE CARD */}

                        <Paper
                            radius="30px"
                            p="xl"
                            mb="xl"
                            style={{
                                background: "rgba(255,255,255,0.05)",
                                backdropFilter: "blur(18px)",
                                border: "1px solid rgba(255,255,255,0.08)",
                            }}
                        >
                            <Group justify="space-between" align="center">
                                <Group>
                                    <Avatar
                                        size={90}
                                        radius="xl"
                                        color="blue"
                                        variant="filled"
                                    // name={profileInputs?.fullname}
                                    >
                                    </Avatar>

                                    <div>
                                        <Title c="white" order={2}>
                                            Profile
                                        </Title>

                                        <Text c="dimmed">
                                            Complete your professional profile
                                        </Text>

                                        <Badge
                                            mt="sm"
                                            color="green"
                                            variant="light"
                                        >
                                            Legal Professional
                                        </Badge>
                                    </div>
                                </Group>

                                <ThemeIcon
                                    size={70}
                                    radius="xl"
                                    variant="light"
                                    color="indigo"
                                >
                                    <IconScale size={36} />
                                </ThemeIcon>
                            </Group>
                        </Paper>

                        <Grid gutter="xl">
                            {/* PERSONAL DETAILS */}

                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <Card
                                    radius="30px"
                                    p="xl"
                                    style={{
                                        background: "rgba(255,255,255,0.05)",
                                        backdropFilter: "blur(18px)",
                                        border: "1px solid rgba(255,255,255,0.08)",
                                        height: "100%",
                                        color: "white"
                                    }}
                                >
                                    <Group mb="lg">
                                        <ThemeIcon
                                            size={50}
                                            radius="xl"
                                            color="blue"
                                            variant="light"
                                        >
                                            <IconUser size={28} />
                                        </ThemeIcon>

                                        <div>
                                            <Title order={3} c="white">
                                                Personal Details
                                            </Title>

                                            <Text c="dimmed" size="sm">
                                                Basic information
                                            </Text>
                                        </div>
                                    </Group>

                                    <Divider mb="lg" />

                                    <Stack>
                                        <TextInput
                                            label="Full Name"
                                            placeholder="Enter full name"
                                            // radius="xl"
                                            size="md"
                                            leftSection={<IconUser size={18} />}
                                            name="fullname"
                                            value={profileInputs.fullname}
                                            disabled
                                            required
                                        // onChange={HandleChange}
                                        />

                                        <TextInput
                                            label="Mobile Number"
                                            placeholder="Enter mobile number"
                                            // radius="xl"
                                            size="md"
                                            leftSection={<IconPhone size={18} />}
                                            name="mobilenumber"
                                            value={profileInputs.mobilenumber}
                                            // onChange={HandleChange}
                                            disabled
                                            required
                                        />

                                        <TextInput
                                            label="Email Address"
                                            placeholder="Enter email address"
                                            // radius="xl"
                                            size="md"
                                            leftSection={<IconMail size={18} />}
                                            name="email"
                                            value={profileInputs.email}
                                            // onChange={HandleChange}
                                            disabled
                                            required
                                        />

                                        <Textarea
                                            label="Office Address"
                                            placeholder="Enter office address"
                                            // radius="xl"
                                            autosize
                                            minRows={3}
                                            name="officeaddress"
                                            value={profileInputs.officeaddress}
                                            onChange={HandleChange}
                                            required
                                        />

                                        <SimpleGrid cols={2}>
                                            <TextInput
                                                label="City"
                                                placeholder="Delhi"
                                                // radius="xl"
                                                leftSection={<IconMapPin size={18} />}
                                                name="city"
                                                value={profileInputs.city}
                                                onChange={HandleChange}
                                                required
                                            />

                                            <TextInput
                                                label="State"
                                                placeholder="Delhi"
                                                // radius="xl"
                                                leftSection={<IconBuilding size={18} />}
                                                name="state"
                                                value={profileInputs.state}
                                                onChange={HandleChange}
                                                required
                                            />
                                        </SimpleGrid>
                                    </Stack>
                                </Card>
                            </Grid.Col>

                            {/* PROFESSIONAL DETAILS */}

                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <Card
                                    radius="30px"
                                    p="xl"
                                    style={{
                                        background: "rgba(255,255,255,0.05)",
                                        backdropFilter: "blur(18px)",
                                        border: "1px solid rgba(255,255,255,0.08)",
                                        height: "100%",
                                        color: "white"
                                    }}
                                >
                                    <Group mb="lg">
                                        <ThemeIcon
                                            size={50}
                                            radius="xl"
                                            color="violet"
                                            variant="light"
                                        >
                                            <IconBriefcase size={28} />
                                        </ThemeIcon>

                                        <div>
                                            <Title order={3} c="white">
                                                Professional Details
                                            </Title>

                                            <Text c="dimmed" size="sm">
                                                Legal practice information
                                            </Text>
                                        </div>
                                    </Group>

                                    <Divider mb="lg" />

                                    <Stack>
                                        <TextInput
                                            label="Bar Council Enrollment Number (Optional)"
                                            placeholder="Enter enrollment number"
                                            // radius="xl"
                                            name="barcouncilnumber"
                                            value={profileInputs.barcouncilnumber}
                                            onChange={HandleChange}
                                        />

                                        <Select
                                            label="Practice Court"
                                            placeholder="Select court"
                                            //  radius="xl"
                                            data={[
                                                "Supreme Court",
                                                "High Court",
                                                "District Court",
                                            ]}
                                            name="practicecourt"
                                            value={profileInputs.practicecourt}
                                            onChange={(value) =>
                                                setProfileInputs({
                                                    ...profileInputs,
                                                    practicecourt: value,
                                                })
                                            }
                                            required
                                        />
                                        {
                                            (profileInputs.practicecourt === "District Court" || profileInputs.practicecourt === "High Court") && (
                                                <TextInput
                                                    label="Court Name"
                                                    placeholder="Tis Hazari Court"
                                                    // radius="xl"
                                                    name="courtname"
                                                    value={profileInputs.courtname}
                                                    onChange={HandleChange}
                                                    required
                                                />
                                            )
                                        }


                                        <TextInput
                                            label="Years of Experience"
                                            placeholder="5 Years"
                                            // radius="xl"
                                            name="experience"
                                            value={profileInputs.experience}
                                            onChange={HandleChange}
                                            required
                                        />


                                        <Select
                                            label="Specialization"
                                            placeholder="Select specialization"
                                            // radius="xl"
                                            searchable
                                            data={[
                                                "Criminal",
                                                "Civil",
                                                "Family",
                                                "Corporate",
                                                "Cyber Crime",
                                                "Taxation",
                                                "Property",
                                                "Consumer",
                                                "Banking",
                                                "Arbitration",
                                            ]}
                                            value={profileInputs.specialization}
                                            onChange={(value) =>
                                                setProfileInputs({
                                                    ...profileInputs,
                                                    specialization: value,
                                                })
                                            }
                                            required
                                        />



                                        <TextInput
                                            label="Department / Section"
                                            placeholder="Criminal Section"
                                            // radius="xl"
                                            name="departmentsection"
                                            value={profileInputs.departmentsection}
                                            onChange={HandleChange}
                                            required
                                        />

                                        <TextInput
                                            label="Clerk ID (Optional)"
                                            placeholder="Enter clerk ID"
                                            // radius="xl"
                                            name="clerkid"
                                            value={profileInputs.clerkid}
                                            onChange={HandleChange}
                                        />

                                        <TextInput
                                            label="Working Under Advocate/Judge (Optional)"
                                            placeholder="Senior advocate/judge name"
                                            // radius="xl"
                                            name="workingunder"
                                            value={profileInputs.workingunder}
                                            onChange={HandleChange}
                                        />
                                    </Stack>
                                </Card>
                            </Grid.Col>
                        </Grid>

                        {/* SAVE BUTTON */}

                        <Center mt="xl">
                            <Button
                                size="lg"
                                radius="xl"
                                leftSection={<IconDeviceFloppy size={20} />}
                                variant="gradient"
                                gradient={{ from: "indigo", to: "cyan" }}
                                onClick={SaveProfile}
                                loading={submitloading}
                            >
                                Save Profile
                            </Button>
                        </Center>
                    </Container>

                </Box>


            </Box>


        </>
    )
}
export default Profile;